import { useEffect, useState } from 'react'
import { fetchDashboardSalesStats, type DashboardSalesStats } from '../services/dashboardService'

export function useDashboardSalesStats(storeId: number | undefined, enabled: boolean) {
  const [stats, setStats] = useState<DashboardSalesStats | null>(null)
  const [loading, setLoading] = useState(enabled)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!enabled) {
      setStats(null)
      setLoading(false)
      setError(null)
      return
    }
    setLoading(true)
    setError(null)
    fetchDashboardSalesStats(storeId)
      .then(setStats)
      .catch((e) => {
        setStats(null)
        setError(e instanceof Error ? e.message : 'Could not load sales metrics')
      })
      .finally(() => setLoading(false))
  }, [storeId, enabled])

  return { stats, loading, error }
}
